import React, { useContext, useEffect, useState } from "react";
import {
    get_product_detail_transection,
} from "../../../Utility/Api";
import { toast } from "react-toastify";
import "../../../Utility/pagination.css";
import { Deletemodel, Pagination } from "../../Common/Functions";
import { isReadonlyRoute, NaviGate, getStoredEntriesPerPage } from "../../../Utility/function";
import { WarehouseContext } from "../../../Utility/UserContext";
import { useLocation } from "react-router-dom";
import { EditRawTransection } from "./rtransfrm";

function ProductDetailTransaction() {
    const { pathname } = useLocation();
    const readonly = isReadonlyRoute(pathname);
    const { showLoader, hideLoader } = useContext(WarehouseContext);

    const [rawmaterials, setRawmaterials] = useState([]);
    const [selectedRaw, setSelectedRaw] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const [addOrEdit, setAddOrEdit] = useState(true);
    const [transactionType, setTransactionType] = useState("1");
    const [preSelectedMaterial, setPreSelectedMaterial] = useState(null);
    const [viewType, setViewType] = useState("add");

    const [deleteID, setDeleteID] = useState("");
    const [deletemodel, showDeletemodel] = useState(false);

    const [totalPages, setTotalPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [entriesPerPage, setEntriesPerPage] = useState(getStoredEntriesPerPage(10));
    const [searchText, setSearchText] = useState("");

    useEffect(() => {
        fetchRawmaterials(currentPage, entriesPerPage, searchText);
    }, [viewType, currentPage, entriesPerPage, searchText]);

    const handledeletemodel = (ID) => {
        showDeletemodel(true);
        setDeleteID(ID);
    };

    const fetchRawmaterials = async (page = currentPage, limit = entriesPerPage, search = searchText) => {
        showLoader();
        try {
            const addTakenParam = viewType === "add" ? "1" : "0";
            const response = await get_product_detail_transection(addTakenParam, page, limit, search);
            if (response.data && response.data.data) {
                setRawmaterials(response.data.data);
                const calcPages = response.data.pagination?.total_pages || Math.max(1, Math.ceil((response.data.pagination?.total_records || response.data.data.length) / limit));
                setTotalPages(calcPages);
            }
        } catch (error) {
            console.error("Error fetching raw materials:", error);
            toast.error("Failed to fetch raw materials");
        } finally {
            hideLoader();
        }
    };

    const openAddModal = (type = "1", material = null) => {
        setAddOrEdit(true);
        setSelectedRaw(null);
        setTransactionType(type);
        setPreSelectedMaterial(material);
        setShowEditModal(true);
    };

    const openEditModal = (raw) => {
        setSelectedRaw(raw);
        setAddOrEdit(false);
        setPreSelectedMaterial(null);
        setShowEditModal(true);
    };

    const handleSearch = (text) => {
        setSearchText(text);
        setCurrentPage(1);
    };

    const handleViewTypeChange = (type) => {
        setViewType(type);
        setCurrentPage(1);
    };

    const handlePageChange = (pageNumber) => {
        if (pageNumber < 1 || pageNumber > totalPages) return;
        setCurrentPage(pageNumber);
    };

    return (
        <div className="page-wrappers">
            <div className="page-content">
                <NaviGate />
                <div className="mb-0 d-flex justify-content-between align-items-center">
                    <h6
                        className="mb-0 text-uppercase"
                        style={{ fontFamily: "poppins" }}
                    >
                        Product Detail Transaction List
                    </h6>
                </div>
                <hr className="mt-1" />

                <div className="card">
                    <div className="card-body">
                        {/* Search bar and view toggle buttons */}
                        <div className="row mb-3 align-items-center">
                            <div className="col-12 col-md-6 col-lg-4">
                                <div
                                    className="d-flex position-relative"
                                    style={{ width: "100%" }}
                                >
                                    <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        placeholder="Search..."
                                        value={searchText}
                                        onChange={(e) => handleSearch(e.target.value)}
                                    />
                                    <img
                                        src="/assets/images/icons/search.png"
                                        alt="Search Icon"
                                        style={{
                                            position: "absolute",
                                            right: "12px",
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            height: "18px",
                                            pointerEvents: "none",
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-md-6 col-lg-8 text-end">
                                <button
                                    type="button"
                                    className={`btn btn-sm ${viewType === "add" ? "btn-primary" : "btn-outline-primary"} me-2`}
                                    onClick={() => handleViewTypeChange("add")}
                                >
                                    Add List
                                </button>
                                <button
                                    type="button"
                                    className={`btn btn-sm ${viewType === "taken" ? "btn-primary" : "btn-outline-primary"}`}
                                    onClick={() => handleViewTypeChange("taken")}
                                >
                                    Taken List
                                </button>
                            </div>
                        </div>

                        <div className="table-responsive">
                            <table
                                className="table table-striped table-sm table-bordered"
                                style={{ width: "100%", fontFamily: "poppins" }}
                            >
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Date</th>
                                        <th>Product(Package)</th>
                                        <th>{viewType === "add" ? "Total Qty" : "Taken Qty"}</th>
                                        {viewType === "add" && <th>Remaining</th>}
                                    </tr>
                                </thead>
                                <tbody>
                                    {rawmaterials.length > 0 ? (
                                        rawmaterials.map((raw, index) => (
                                            raw.product_name && <tr key={raw.id || index}>
                                                <td>{(currentPage - 1) * entriesPerPage + index + 1}</td>
                                                <td>
                                                    {new Date(raw.create_date).toLocaleDateString("en-GB", {
                                                        day: "2-digit",
                                                        month: "short",
                                                        year: "numeric",
                                                    })}
                                                </td>
                                                <td>
                                                    {raw.product_name && (
                                                        raw.pbox_code === "FREE SIZE / LOSE QTY" || raw.p_code === "FREE_SIZE"
                                                            ? `${raw.product_name} Lose Packs`
                                                            : raw.p_weight
                                                                ? `${raw.product_name} ${raw.p_weight} ${raw.pbox_unit || ''}`
                                                                : `${raw.product_name} ${raw.pbox_unit || ''}`
                                                    )}
                                                </td>
                                                <td>
                                                    {raw.qty != null ? Number(raw.qty).toFixed(2) : "0.00"}{" "} {raw.unit_id === "1" ? "kg" : raw.unit_id === "2" ? "gram" : ""}
                                                </td>
                                                {viewType === "add" && <td>{Number(raw.remaining).toFixed(2)}{" "} {raw.unit_id === "1" ? "kg" : raw.unit_id === "2" ? "gram" : ""}</td>}
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={viewType === "add" ? "5" : "4"} className="text-center py-3">
                                                No transactions found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            <Pagination
                                currentPage={currentPage}
                                totalPages={totalPages}
                                onPageChange={handlePageChange}
                                entriesPerPage={entriesPerPage}
                                onEntriesPerPageChange={(val) => {
                                    setEntriesPerPage(val);
                                    setCurrentPage(1);
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ProductDetailTransaction;